// extracted by mini-css-extract-plugin
export default {"overlay":"CelebrateModule_overlay__JESw9","content":"CelebrateModule_content__sGvr+","close":"CelebrateModule_close__7EybU","footer":"CelebrateModule_footer__VgqOr"};